import React, { useState, useEffect } from "react";
import {
  Input, InputGroup, InputGroupText,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Table
} from "reactstrap";
import { AiOutlineSearch, AiOutlineArrowRight } from "react-icons/ai";
import api from "../../service/api";
import ModalComponent from "../Modal/ModalComponent";
import styles from "./ModalVidasComponent.module.css";

export default function ModalVidasComponent({ questionario, onClose }) {
  const [vidas, setVidas]         = useState([]);
  const [filtradas, setFiltradas] = useState([]);
  const [busca, setBusca]         = useState("");
  const [isSent, setIsSent]       = useState(false);

  useEffect(() => {
    setIsSent(false);
    api.get("vida")
      .then(({ data }) =>
        setVidas(data.sort((a, b) => a.vida_nome.localeCompare(b.vida_nome)))
      )
      .catch(console.error);
  }, []);

  useEffect(() => {
    const lower = busca.toLowerCase();
    setFiltradas(vidas.filter(v => v.vida_nome.toLowerCase().includes(lower)));
  }, [busca, vidas]);

  const enviar = (vida_id, telefone) => {
    api.post("envioQuestionario", {
      idVida: vida_id,
      questionario
    })
    .then(({ data }) => {
      const url =
        "https://api.whatsapp.com/send?phone=55" +
        parseInt(telefone.replace(/\D/g, "")) +
        "&text=Link para responder o questionário " +
        process.env.REACT_APP_FRONT_URL +
        "perguntas/" +
        data.linkCript;
      window.open(url);
      setIsSent(true);
    })
    .catch(console.error);
  };

  return (
    <>
      <ModalComponent
        isOpen={isSent}
        onClose={() => setIsSent(false)}
        mensagem="Questionário enviado com sucesso!"
        icon="SucessoEnvioQuestionario"
      />

      <Modal centered isOpen={true} contentClassName={styles.customModal}>
        <ModalHeader className={styles.modalHeader}>
          Escolha uma Vida
        </ModalHeader>
        <ModalBody className={styles.modalBodyScrollable}>
          <InputGroup>
            <Input
              size="sm"
              placeholder="Busque pelo nome"
              className={styles.inputBusca}
              value={busca}
              onChange={e => setBusca(e.target.value)}
            />
            <InputGroupText className={styles.textBuscar}>
              <AiOutlineSearch size={17} className={styles.iconBuscar} />
              Buscar
            </InputGroupText>
          </InputGroup>

          <Table size="sm" striped className={styles.table}>
            <thead>
              <tr><th>Vida</th><th>Ações</th></tr>
            </thead>
            <tbody>
              {(busca ? filtradas : vidas).map(v => (
                <tr key={v.vida_id}>
                  <td>{v.vida_nome || "Não informado"}</td>
                  <td>
                    <Button
                      size="sm"
                      className={styles.buttonFormulario}
                      onClick={() => enviar(v.vida_id, v.telefone)}
                    >
                      <AiOutlineArrowRight size={17} className={styles.buttonIcon} />
                      Enviar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter className={styles.modalFooter}>
          <Button size="sm" onClick={onClose} className={styles.button}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
